/**
 * JobsLibrarySearchV2.jsx
 *
 * Free-text search box for the Jobs Library header, with suggestions.
 *
 * AutoComplete, not Select (issue #1983): a showSearch Select highlights the
 * first suggestion, so Enter filtered by that option instead of the typed
 * text, and it clears its search text whenever the dropdown closes. Here the
 * typed text is the filter; Enter, blur and Escape leave it alone.
 *
 * Props:
 *   value     string — the current search term (controlled by the page)
 *   options   { value, label }[] — suggestions
 *   onType    (text) => void — every edit to the typed text, including
 *             deleting it all
 *   onPick    (value) => void — a suggestion was picked (click, or arrow
 *             keys + Enter)
 *   onClear   () => void — the clear icon was clicked
 */

import React from "react";
import { AutoComplete } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import SbButton from "uiCore/SbButton/SbButton";

// AutoComplete shows every option unless told otherwise (rc-select turns
// filtering off by default in combobox mode). Use the same case-insensitive
// "contains" rule as the page's table filter, so the suggestions match the rows.
const matchesTypedText = (text, option) =>
  String(option?.value ?? "").toLowerCase().includes(text.trim().toLowerCase());

const JobsLibrarySearchV2 = ({ value, options, onType, onPick, onClear, placeholder }) => (
  <AutoComplete
    options={options}
    value={value}
    filterOption={matchesTypedText}
    suffixIcon={<SbButton buttonType="primary" size="small" icon={<SearchOutlined />} />}
    onSearch={onType}
    onSelect={onPick}
    onClear={onClear}
    placeholder={placeholder}
    allowClear
    notFoundContent="No matching results"
    listHeight={300}
    // Same as SbSelect: attach to the trigger's parent to avoid scroll issues
    getPopupContainer={(triggerNode) => triggerNode?.parentNode || document.body}
  />
);

export default JobsLibrarySearchV2;
